import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader
} from "../../../../_metronic/_partials/controls";
import { getAnswersByScenario } from "../../../../api/answer";
import { getGames } from "../../../../api/game";
import { getGroups } from "../../../../api/group";
import { getSceneById } from "../../../../api/scene";
import { alertError } from "../../../../utils/logger";
import Table, {
	pointsFormatter,
	timeFormatter
} from "../../../components/tables/table";

function getData(groups, answers) {
	let data = [];
	groups.forEach((group) => {
		let groupAnswers = answers.filter((answer) => {
			return answer.group === group._id;
		});
		let result = null;
		if (groupAnswers.length)
			result = groupAnswers?.reduce((a, b) => ({
				score: a.score + b.score,
				time: a.time + b.time,
			}));
		if (result) {
			data = data.concat({
				group: group.fullName,
				pts: result.score,
				time: result.time,
			});
		}
	});

	data.sort((a, b) => {
		if (a.pts !== b.pts) {
			return b.pts - a.pts;
		}
		return a.time - b.time;
	});
	return data;
}

export default function ViewScenePage() {
	const [data, setData] = useState([]);
	const [scenario, setScenario] = useState();
	const [games, setGames] = useState([]);
	const [selectedGameId, setSelectedGameId] = useState("");
	const [refresh, setRefresh] = useState(false);
	const sceneId = useParams().id;

	const columns = [
		{ dataField: "group", text: "Group" },
		{
			dataField: "pts",
			text: "Correct",
			align: "center",
			headerAlign: "center",
			formatter: pointsFormatter,
			sort: true,
		},
		{
			dataField: "time",
			text: "Time",
			align: "center",
			headerAlign: "center",
			formatter: timeFormatter,
			sort: true,
		},
	];

	useEffect(() => {
		getGames()
			.then((res) => {
				if (res.status === 200 && res.data && res.data.length) {
					setGames(res.data);
					const defaultGame = res.data.find((g) => g.default) || res.data[0];
					if (!selectedGameId) setSelectedGameId(defaultGame._id);
				}
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		getSceneById(sceneId)
			.then((res) => {
				if (res.status === 200) {
					setScenario(res.data);
					return getAnswersByScenario(sceneId, selectedGameId || undefined);
				}
			})
			.then((resAnswers) => {
				if (resAnswers && resAnswers.status === 200) {
					return getGroups().then((res) => {
						if (res.status === 200) {
							setData(getData(res.data, resAnswers.data));
							setRefresh(false);
						}
					});
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get the scenario or answers.",
				});
			});
	}, [refresh, sceneId, selectedGameId]);

	return (
		<>
			<Card>
				<CardHeader
					title={`Scenario | ${scenario?.fullName || ""}`}
				></CardHeader>
				<CardBody>
					<div className="form-group mb-4">
						<label htmlFor="view-scene-game-select" className="font-weight-bold">
							Game (Answers shown for this game)
						</label>
						<select
							id="view-scene-game-select"
							className="form-control"
							style={{ maxWidth: 320 }}
							value={selectedGameId}
							onChange={(e) => setSelectedGameId(e.target.value)}
						>
							<option value="">All games</option>
							{games.map((game) => (
								<option key={game._id} value={game._id}>
									{game.fullName}
								</option>
							))}
						</select>
					</div>
					<Table data={data} columns={columns} />
				</CardBody>
			</Card>
		</>
	);
}
